// extracted by mini-css-extract-plugin
export default {"container":"Instructions_container__UyRo0","copyUssd":"Instructions_copyUssd__Xe5kz","code":"Instructions_code__13iGB","inputNote":"Instructions_inputNote__8KifB"};